import React, { useState } from 'react';
import { Card, Tabs, Form, Input, Button, message } from 'antd';
import { UserOutlined, LockOutlined, MailOutlined } from '@ant-design/icons';
import './index.css';

const { TabPane } = Tabs;

const Auth = ({ onLogin, onRegister }) => {
  const [activeTab, setActiveTab] = useState('login');
  const [loginForm] = Form.useForm();
  const [registerForm] = Form.useForm();

  const handleLogin = (values) => {
    const mockUser = {
      id: 1,
      username: values.username,
      email: `${values.username}@example.com`,
      avatar: 'https://via.placeholder.com/50'
    };
    const mockToken = 'mock-jwt-token-' + Date.now();
    onLogin(mockUser, mockToken);
  };

  const handleRegister = (values) => {
    const mockUser = {
      id: Date.now(),
      username: values.username,
      email: values.email,
      avatar: 'https://via.placeholder.com/50'
    };
    const mockToken = 'mock-jwt-token-' + Date.now();
    onRegister(mockUser, mockToken);
  };

  const onTabChange = (key) => {
    setActiveTab(key);
    if (key === 'login') {
      registerForm.resetFields();
    } else {
      loginForm.resetFields();
    }
  };

  return (
    <div className="auth-page">
      <Card className="auth-card" title="欢迎来到我的博客">
        <Tabs activeKey={activeTab} onChange={onTabChange} centered>
          <TabPane tab="登录" key="login">
            <Form
              form={loginForm}
              layout="vertical"
              onFinish={handleLogin}
              className="auth-form"
            >
              <Form.Item
                label="用户名"
                name="username"
                rules={[{ required: true, message: '请输入用户名' }]}
              >
                <Input 
                  prefix={<UserOutlined />} 
                  placeholder="请输入用户名" 
                  size="large"
                />
              </Form.Item>
              <Form.Item
                label="密码"
                name="password"
                rules={[{ required: true, message: '请输入密码' }]}
              >
                <Input.Password 
                  prefix={<LockOutlined />} 
                  placeholder="请输入密码" 
                  size="large"
                />
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" size="large" block>
                  登录
                </Button>
              </Form.Item>
            </Form>
          </TabPane>
          <TabPane tab="注册" key="register">
            <Form
              form={registerForm}
              layout="vertical"
              onFinish={handleRegister}
              className="auth-form"
            >
              <Form.Item
                label="用户名"
                name="username"
                rules={[{ required: true, message: '请输入用户名' }]}
              >
                <Input 
                  prefix={<UserOutlined />} 
                  placeholder="请输入用户名" 
                  size="large"
                />
              </Form.Item>
              <Form.Item
                label="邮箱"
                name="email"
                rules={[
                  { required: true, message: '请输入邮箱' },
                  { type: 'email', message: '请输入有效的邮箱地址' }
                ]}
              >
                <Input 
                  prefix={<MailOutlined />} 
                  placeholder="请输入邮箱" 
                  size="large"
                />
              </Form.Item>
              <Form.Item
                label="密码"
                name="password"
                rules={[
                  { required: true, message: '请输入密码' },
                  { min: 6, message: '密码至少6位' }
                ]}
              >
                <Input.Password 
                  prefix={<LockOutlined />} 
                  placeholder="请输入密码" 
                  size="large"
                />
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" size="large" block>
                  注册
                </Button>
              </Form.Item>
            </Form>
          </TabPane>
        </Tabs>
      </Card>
    </div>
  );
};

export default Auth;